import { PDFRasterize } from "@pdfking/renderer-default"
import { Range } from "@pdfking/tfunc"

import { CastPDFReaderOptions } from "../../files/CastPDFReaderOptions"
import { GenerateFile } from "../../files/GenerateFile"
import { ConvertRectangle } from "../../geometry/ConvertRectangle"
import type { PdfEngine } from "../../types/engine/PdfEngine"
import { ContentType } from "../../types/files/ContentType"
import { VirtualFileType } from "../../types/files/VirtualFileType"
import type { TaskResult } from "../../types/tasks/input/TaskResult"
import type { TaskRasterizeOptions } from "../../types/tasks/options/TaskRasterizeOptions"
import { TaskName } from "../../types/tasks/TaskName"
import { TrackedTaskName } from "../../types/tasks/tracking/TrackedTaskName"
import type { TrackingCallback } from "../../types/tasks/tracking/TrackingCallback"

export async function* TaskRasterize(
  engine: PdfEngine,
  task: TaskRasterizeOptions,
  emit: TrackingCallback
): AsyncGenerator<TaskResult> {
  const readerOptions = await CastPDFReaderOptions(
    engine,
    task.options,
    task.source,
    emit
  )

  void emit({
    name: TrackedTaskName.RASTERIZE_PDF,
    done: 0,
    total: 1,
  })

  const results = PDFRasterize(readerOptions, page_count => {
    if (page_count !== 1) {
      throw new Error(`Expected 1 page, got ${page_count}`)
    }
    return Range(1, 1)
  })

  for await (const { blob, size } of results) {
    const content = await GenerateFile(engine, [blob], ContentType.PNG)

    yield {
      enum: TaskName.CONTENT_FILE,
      name: "img.png",
      content: {
        enum: VirtualFileType.SINGLE_PAGE_IMAGE,
        source: task.source,
        content,
        file_meta: {},
        size: ConvertRectangle(task.options, size),
      },
    } as TaskResult

    void emit({
      name: TrackedTaskName.RASTERIZE_PDF,
      done: 1,
      total: 1,
    })
  }
}
